import { PropTypes } from 'prop-types';
import { Button, Pagination } from 'antd';
import { useIntl } from 'react-intl';

const AccionaTablePagination = ({ pagination, setPagination }) => {
  const intl = useIntl();
  const itemRender = (page, type, originalElement) => {
    const isFirstPage = pagination.current === 1;
    const isLastPage =
      pagination.current === Math.ceil(pagination.total / pagination.pageSize);

    if (type === 'prev') {
      return (
        <Button
          type="link"
          disabled={isFirstPage}
          style={isFirstPage ? { color: '#ccc', cursor: 'not-allowed' } : {}}
        >
          {intl.formatMessage({ id: 'previous' })}
        </Button>
      );
    }
    if (type === 'next') {
      return (
        <Button
          type="link"
          disabled={isLastPage}
          style={isLastPage ? { color: '#ccc', cursor: 'not-allowed' } : {}}
        >
          {intl.formatMessage({ id: 'next' })}
        </Button>
      );
    }

    return (
      <span style={page === pagination.current ? { color: 'white' } : {}}>
        {page}
      </span>
    );
  };

  return (
    <Pagination
      current={pagination.current}
      showSizeChanger={false}
      size="large"
      pageSize={pagination.pageSize}
      total={pagination.total}
      itemRender={itemRender}
      onChange={(page, pageSize) => {
        return setPagination((prev) => ({
          ...prev,
          current: page,
          pageSize,
        }));
      }}
    />
  );
};

AccionaTablePagination.propTypes = {
  pagination: PropTypes.shape({
    total: PropTypes.number,
    pageSize: PropTypes.number,
    current: PropTypes.number,
  }).isRequired,
  setPagination: PropTypes.func.isRequired,
};

AccionaTablePagination.defaultProps = {};

export default AccionaTablePagination;
